const REGION_BLOCK_MESSAGE =
    "Thank you for your interest! Unfortunately, our services aren't available in your region at the moment. We're working hard to expand and truly hope to welcome you soon.";
export default REGION_BLOCK_MESSAGE
// NITISH  lll ll      
// NITISH  AND GAURAV BEST FRIENDkk           
    
  
